/** Rebrand product copy without changing URLs, HTML attributes or ICU arguments. */
export function productBrandText(message: string): string {
  const protectedToken = /(<[^>]*>|https?:\/\/[^\s<>"']+|`[^`]*`|\{[\w.]+\})/g;

  return message.split(protectedToken).map((part, index) => {
    if (index % 2) {
      return part;
    }

    return part.replace(/\b(?:SUSE\s+)?Rancher(?:\s+Prime)?\b/g, 'Lattice');
  }).join('');
}
